import axios from 'store/axios/axios-gcib';
import axios_crm from 'store/axios/axios-crm';
import axios_gci from 'store/axios/axios-gci';
import axios_gcib from 'store/axios/axios-gcib';
import axios_inv from 'store/axios/axios-invoice';
import { clone, handleError, parseFloatString } from '../../../shared/utility';
import { commissionCalc } from '../../RSheets/CommonCustomElements/CommissionLogic';
import { get } from 'lodash';
import { calculatePaymentSplits } from '../../PaymentReports/paymentReportsLogic';
import { calculateTotalInvoicePicture } from '../../Invoices/InvoiceLogic';

export const fetchGCIB = async (user_id, rs_id) => {
    try {
        if (user_id) {
            const response = await axios.get('/entries?user_id='+user_id);
            return response.data;
        } else if (rs_id) {
            const response = await axios.get('/entries?rs_id='+rs_id);
            return response.data;
        }
        const response = await axios.get('/entries');
        return response.data;
    } catch(e) {
        handleError(e);
        alert('Could not fetch GCI Board entries');
    }
    return null;
}

export const generateGCIB = async (data, rs_id) => {
    console.log('gcib rs #', data);
    console.log('gcibb 1');
    // get ALL GCI percentages 
    let gci_entries = [];
    try {
        const response = await axios_gci.get('/entries');
        gci_entries = response.data;
    } catch (e) {
        handleError(e);
    }
    console.log('gci_entries', gci_entries);

    // get RS ID
    const obj = {};
    obj.rs_id = rs_id;
    // get lease signed date 
    obj.date_lease_signed = data.date_lease_signed;
    obj.all_commission_calculations = commissionCalc.calculate(data);
    console.log('all_commission_calculations', obj.all_commission_calculations);
    console.log('gcibb 2');
    // get all Invoices by RS ID 
    obj.invoices = [];
    try {   
        const response = await axios_inv.get('/entries?rs_id='+obj.rs_id);
        obj.invoices = response.data;
    } catch(e) {
        handleError(e);
    }

    // get associates and their last commission levels
    obj.lessee_side_associates = clone(data.commission_splits_agent2);
    obj.lessor_side_associates = clone(data.commission_splits_agent);
    obj.assignor_side_associates = data.commission_splits_agent3 ? clone(data.commission_splits_agent3) : [];
    console.log('gcibb 3');
    let users = [];
    // Get illi_users with connect_user_id
    try {
        const response = await axios_crm.get('/contact_usernames?type=all');
        console.log('cresponse', response.data);
        users = response.data;
    } catch(e) {
        handleError(e);
    }
        
    for (let j = 0; j < obj.lessee_side_associates.length; j++) {
        const cont = obj.lessee_side_associates[j];
        let user = null;
        for (let i = 0; i < users.length; i++) {
            const usr = users[i];
            if (usr.contact_id === cont.id && !user) {
                user = usr;
            }
        }
        // found contact - user 
        if (user) {
            cont.connect_user_id = user.id;
            try {
                const gci = await axios.get('/user?user_id='+user.id);
                console.log('gickle', gci.data, user.id);
                if (gci.data) {
                    cont.gci_data = gci.data;
                }
            } catch(err) {
                handleError(err);
            }
        } else {
            console.log('1 could not find', cont);
        }
    }
    for (let j = 0; j < obj.lessor_side_associates.length; j++) {
        const cont = obj.lessor_side_associates[j];
        let user = null;
        for (let i = 0; i < users.length; i++) {
            const usr = users[i];
            if (usr.contact_id === cont.id && !user) {
                user = usr;
            }
        }
        if (user) {
            cont.connect_user_id = user.id;
            try {
                const gci = await axios.get('/user?user_id='+user.id);
                console.log('gickle', gci.data, user.id);
                if (gci.data) {
                    cont.gci_data = gci.data;
                }
            } catch(err) {
                handleError(err);
            }
        } else {
            console.log('2 could not find', cont);
        }
    }
    for (let j = 0; j < obj.assignor_side_associates.length; j++) {
        const cont = obj.assignor_side_associates[j];
        let user = null;
        for (let i = 0; i < users.length; i++) {
            const usr = users[i];
            if (usr.contact_id === cont.id && !user) {
                user = usr;
            }
        }
        if (user) {
            cont.connect_user_id = user.id;
            try {
                const gci = await axios.get('/user?user_id='+user.id);
                console.log('gickle', gci.data, user.id);
                if (gci.data) {
                    cont.gci_data = gci.data;
                }
            } catch(err) {
                handleError(err);
            }
        } else {
            console.log('3 could not find', cont);
        }
    }
    console.log('gcibb 4');
    // COLLECT EVERYBODY, by unique name / user id
    let everybody = [];
    for (let i = 0; i < obj.lessee_side_associates.length; i++) {
        const olsa = obj.lessee_side_associates[i];
        let found = false;
        everybody.forEach(e => {
            if (e.user_id === olsa.id) {
                found = true;
            }
        })
        if (!found) everybody.push({
            user_id: olsa.id,
            name: olsa.Name,
            ytd_earnings: 0
        });
    }
    for (let i = 0; i < obj.lessor_side_associates.length; i++) {
        const olsa = obj.lessor_side_associates[i];
        let found = false;
        everybody.forEach(e => {
            if (e.user_id === olsa.id) {
                found = true;
            }
        })
        if (!found) everybody.push({
            user_id: olsa.id,
            name: olsa.Name,
            ytd_earnings: 0
        });
    }
    for (let i = 0; i < obj.assignor_side_associates.length; i++) {
        const olsa = obj.assignor_side_associates[i];
        let found = false;
        everybody.forEach(e => {
            if (e.user_id === olsa.id) {
                found = true;
            }
        })
        if (!found) everybody.push({
            user_id: olsa.id,
            name: olsa.Name,
            ytd_earnings: 0
        });
    }
    console.log('gcibb 5');
    for (let i = 0; i < obj.lessee_side_associates.length; i++) {
        const olsa = obj.lessee_side_associates[i];
        await processAssociate(
            clone(olsa), 
            clone(obj), 
            clone(data), 
            clone(gci_entries), 
            'Lessee',
            everybody
        );
    }
    for (let i = 0; i < obj.lessor_side_associates.length; i++) {
        const olsa = obj.lessor_side_associates[i];
        await processAssociate(
            clone(olsa), 
            clone(obj), 
            clone(data), 
            clone(gci_entries), 
            'Lessor',
            everybody
        );
    }
    for (let i = 0; i < obj.assignor_side_associates.length; i++) {
        const olsa = obj.assignor_side_associates[i];
        await processAssociate(
            clone(olsa), 
            clone(obj), 
            clone(data), 
            clone(gci_entries), 
            'Assignor',
            everybody
        );
    }
    console.log('gcibb 6');
}

export const getThreshold = (level, gci_entries) => {
    let threshold = 0;
    gci_entries.forEach(gcie => {
        if (gcie.commission_level === level) {
            threshold = parseFloatString(gcie.threshold);
        }
    })
    return threshold;
}

export const checkIfGCIOverride = (obj) => {
    let is_override = false;
    if (obj) {
        if (obj.contact_id && obj.rs_data && obj.side) {
            const rs_data = obj.rs_data;
            if (rs_data.is_gci_override === 'Yes') {
                if (rs_data.gci_overrides) {
                    let assoc_rate = 0;
                    Object.keys(rs_data.gci_overrides).forEach(gcid => {
                        const contact_id = parseInt(gcid.split('_')[0]);
                        const side = gcid.split('_')[1];
                        if (side === obj.side && contact_id === obj.contact_id) {
                            assoc_rate = parseFloatString(rs_data.gci_overrides[gcid].associate_splits) * 0.01;
                        }
                    });
                    if (assoc_rate) {
                        is_override = true;
                    }
                }
            }
        }
    }
    return is_override;
}

export const getGCIRate = (level, gci_entries, obj) => {
    if (obj) {
        if (obj.contact_id && obj.rs_data && obj.side) {
            const rs_data = obj.rs_data;
            if (rs_data.is_gci_override === 'Yes') {
                if (rs_data.gci_overrides) {
                    let assoc_rate = 0;
                    Object.keys(rs_data.gci_overrides).forEach(gcid => {
                        const contact_id = parseInt(gcid.split('_')[0]);
                        const side = gcid.split('_')[1];
                        if (side === obj.side && contact_id === obj.contact_id) {
                            assoc_rate = parseFloatString(rs_data.gci_overrides[gcid].associate_splits) * 0.01;
                        }
                    });
                    if (assoc_rate) return assoc_rate;
                }
            }
        }
    }

    let rate = parseFloatString(gci_entries[0].percentage) * 0.01;
    gci_entries.forEach(gcie => {
        if (gcie.commission_level === level) {
            rate = parseFloatString(gcie.percentage) * 0.01;
        }
    })
    return rate;
}

const calculateAfterPresplitsCommission = (obj, data) => {
    let commission = parseFloatString(obj.all_commission_calculations.gross_commission);
    let original_commission = parseFloatString(obj.all_commission_calculations.gross_commission);
    // get through presplits
    if (data.presplits) {
        data.presplits.forEach(dp => {
            if (dp.value_type === 'Dollar Value') {
                commission -= parseFloatString(dp.dollar_value);
            } else {
                commission -= (parseFloatString(dp.percentage_value) * 0.01) * original_commission;
            }
        });
    }
    return commission;
}

export const getLastGCILevel = async (user_id) => {
    let level = 1;
    try {
        const users = await axios_gcib.get('/user?user_id='+user_id);
        if (users.data) {
            const user = users.data[0];
            if (user) {
                level = user.current_commission_level ? 
                    parseInt(user.current_commission_level)
                :
                    1;
            }
        }
    } catch(e) {    
        handleError(e);
    }
    return level;
}

export const getGCIEntries = async () => {
    let entries = []
    try {
        const response = await axios_gci.get('/entries');
        entries = response.data;
    } catch(e) {
        handleError(e);
    }
    return entries;
}

export const getCommissionEarned = async (current_year, user_id) => {
    // for the whole year
    let ytd_earned = 0;
    try {
        let year_to_date_most_recent_board_entries = [];
        const response = await axios_gcib.get('/entries?user_id='+user_id);
        const dat = response.data;
        console.log('json_data gci board entry most recent', dat)

        year_to_date_most_recent_board_entries = dat.filter(dd => {
            const json = dd.json_data;
            // filter by Year 
            if (json.commission_earned_year === current_year) {
                return true;
            }
        });
        // GCIB by year
        year_to_date_most_recent_board_entries.forEach(be => {
            const payments = be.payments;
            if (payments) {
                payments.forEach(p => {
                    ytd_earned += p.payment_to_commission;
                })
            }
        });
    } catch(e) {
        handleError(e);
    }
    return ytd_earned;
}

export const processAssociate = async (olsa, obj, data, gci_entries, associate_side_on_rs, everybody) => {
    const invoices = obj.invoices;
    // Makes GCIB entry which is per Associate, per side, per invoice, all payments in that invoice
    for (let x = 0; x < invoices.length; x++) {
        const number_of_invoices = invoices.length;
        const invoice = invoices[x];
        // there are no payments yet, estimate 
        const all_data = await calculateTotalInvoicePicture(obj.rs_id);
        // get last gci level of user
        let gci_level = 1;
        const gc_inquiry = await getLastGCILevel(olsa.connect_user_id);
        if (gc_inquiry) {
            gci_level = gc_inquiry;
        }
        const distObj = calculatePaymentSplits(all_data, invoice.id, null, gci_level, gci_entries);
        console.log('gcibb 3');
        console.log('processed distobj', distObj, invoice.id);
        const dat = {
            rs_id: obj.rs_id,
            user_id: olsa.connect_user_id,
            distObj
        }
        const current_year = new Date().getFullYear();
        // get associate's data
        let assoc_data = {};
        let field = '';
        if (associate_side_on_rs === 'Lessee') {
            field = 'associate_commission_splits_lessee';
        } else if (associate_side_on_rs === 'Lessor') {
            field = 'associate_commission_splits_lessor';
        } else if (associate_side_on_rs === 'Assignor') {
            field = 'associate_commission_splits_assignor';
        }
        // NOTE: TEMPORARILY not used
        obj.all_commission_calculations[field].forEach(cl => {
            if (olsa.id === cl.id) {
                assoc_data = cl;
            }
        });
        // get percentage e.g. 0.04 = 4%
        let associate_side_on_rs_percent = 0;
        let associate_total_everyone_on_side = 0;
        let associate_side_commission = 0; // total before house gets payment
        let associate_commission_on_rs = 0;

        if (associate_side_on_rs === 'Lessee') {
            associate_side_on_rs_percent = parseFloatString(data.commission_distribution_lessee) * 0.01;
            distObj.lessee_illi_associates.forEach(lia => {
                associate_total_everyone_on_side += lia.dollar_value;

                if (lia.user_id === olsa.connect_user_id) {
                    associate_side_commission = lia.dollar_value;
                    associate_commission_on_rs = lia.due_to_associate_number;
                }
            })
        } else if (associate_side_on_rs === 'Lessor') {
            associate_side_on_rs_percent = parseFloatString(data.commission_distribution_lessor) * 0.01;
            distObj.lessor_illi_associates.forEach(lia => {
                associate_total_everyone_on_side += lia.dollar_value;

                if (lia.user_id === olsa.connect_user_id) {
                    associate_side_commission = lia.dollar_value;
                    associate_commission_on_rs = lia.due_to_associate_number;
                }
            })
        } else if (associate_side_on_rs === 'Assignor') {
            associate_side_on_rs_percent = parseFloatString(data.commission_distribution_assignor) * 0.01;
            distObj.assignor_illi_associates.forEach(lia => {
                associate_total_everyone_on_side += lia.dollar_value;

                if (lia.user_id === olsa.connect_user_id) {
                    associate_side_commission = lia.dollar_value;
                    associate_commission_on_rs = lia.due_to_associate_number;
                }
            })
        }   
        console.log('gcibb 8');
        let last_gci_level = get(olsa, 'gci_data[0].current_commission_level', 1);
        // get last
        try {
            const response = await axios.get('/user?user_id='+olsa.connect_user_id);
            const users = response.data;
            if (users[0]) {
                last_gci_level = users[0].current_commission_level;
            }
        } catch(e) {
            handleError(e);
        }
        const json_data = {
            distObj,
            olsa,
            obj,
            data,
            user_id: olsa.connect_user_id,
            gci_entries,
            date_lease_signed: obj.date_lease_signed,
            rs_id: obj.rs_id,
            total_commission_on_rs: obj.all_commission_calculations.gross_commission, // total commission
            associate_side_on_rs, // Lessee or Lessor
            associate_side_total_commission: associate_side_commission, // BASED OFF distObj - Total before house payout
            associate_side_on_rs_percent, // %
            associate_percent_commission_on_rs: parseFloatString(olsa.Percentage) * 0.01,

            // total commission associate side x associate % comm on RS
            associate_commission_on_rs: associate_total_everyone_on_side * (parseFloatString(olsa.Percentage) * 0.01), 

            // pending payment
            associate_commission_to_payout: associate_side_commission, // PREVIOUSLY: assoc_data.value / number_of_invoices,
            gci_level: last_gci_level, // look at the most recent GCI level from users table
            gci_threshold: getThreshold(last_gci_level, gci_entries),

            // commission earned during the year - this value is starting only - CALCULATE
            commission_earned: await getCommissionEarned(current_year, olsa.connect_user_id),
            commission_earned_for_real: 0,
            commission_earned_year: current_year,
            
            gci_entries,
            gci_rate: getGCIRate(last_gci_level, gci_entries, {
                contact_id: olsa.id,
                rs_data: data,
                side: associate_side_on_rs
            }),
            gci_pay_amount: '',
            invoice_id: invoice.id,
            invoice_number: invoice.invoice_num, // later on
            payments: [],
            // payment_received: '', // later on
            // payment_received_date: '' // later on
        }
        console.log('gcibb 9');
        console.log('json_data gci board entry', olsa.Name, json_data)
        
        dat.json_data = JSON.stringify(json_data);
        dat.invoice_id = json_data.invoice_id;
        await axios_gcib.post('/entry', dat);
        console.log('gcibb 10');
    }
    
}